/* jshint ignore:start */
var Z = window.Z || {};
Z.settings = Z.settings || {};

var svgTemplate = [
    '<?xml version="1.0" encoding="UTF-8"?>',
    '<svg width="25px" height="34px" viewBox="0 0 25 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">',
    '<g id="Physician-Finder" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">',
    '<g id="Nevro_Wireframe_PhysicianFinder_Marker02" stroke="#FFFFFF">',
    '<g id="Marker-Copy-3">',
    '<path d="M11.5,0 C5.14214286,0 0,5.1645 0,11.55 C0,20.2125 11.5,33 11.5,33 C11.5,33 23,20.2125 23,11.55 C23,5.1645 17.8578571,0 11.5,0 L11.5,0 Z" id="Shape" fill="#00B3E2"></path>',
    '<path d="M11,15 C8.792,15 7,13.208 7,11 C7,8.792 8.792,7 11,7 C13.208,7 15,8.792 15,11 C15,13.208 13.208,15 11,15 L11,15 Z" id="Path" fill="#FFFFFF"></path>',
    '</g>',
    '</g>',
    '</g>',
    '</svg>'
].join('\n');

var svgSelectedTemplate = [
   '<?xml version="1.0" encoding="utf-8"?>',
   '<!-- Generator: Adobe Illustrator 25.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->',
   '<svg version="1.1" id="Pin" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 23.5 33.9" style="enable-background:new 0 0 23.5 33.9;" xml:space="preserve">',
   '<style type="text/css"> .st0{fill:#004C9D;} .st1{fill:#FFFFFF;} </style>',
   '<path class="st0" d="M11.8,0C5.3,0,0,5.3,0,11.8C0,12.9,0.2,14,0.5,15c0.1,0.6,0.3,1.2,0.6,1.8c2.5,4.4,10.7,17.1,10.7,17.1 S20,21.2,22.4,16.8c0.3-0.6,0.5-1.2,0.7-1.8c0.3-1,0.4-2.1,0.4-3.2C23.6,5.3,18.4,0.1,11.8,0L11.8,0z"/>',
   '<polygon class="st1" points="7.1,7.1 7.1,9.9 4.5,9.9 4.5,7.1 3.3,7.1 3.3,13.7 4.5,13.7 4.5,11 7.1,11 7.1,13.7 8.4,13.7 8.4,7.1 "/>',
   '<polygon class="st1" points="9.9,7.1 9.9,13.7 11.2,13.7 11.2,11 14,11 14,9.9 11.2,9.9 11.2,8.2 14,8.2 14,7.1 "/>',
   '<path class="st1" d="M20.3,7.1h-1c-0.1,0-0.3,0-0.4,0.1s-0.2,0.1-0.3,0.3c-0.1,0.1-0.9,1.3-0.9,1.3l0.7,1.1L20.3,7.1z"/>',
   '<path class="st1" d="M16.1,7.5C16,7.4,16,7.3,15.8,7.2c-0.1-0.1-0.3-0.1-0.4-0.1h-1l2.2,3.3l-2.2,3.3h1c0.1,0,0.3,0,0.4-0.1 c0.1-0.1,0.2-0.1,0.3-0.3c0.1-0.1,2-3,2-3S16.2,7.6,16.1,7.5"/>',
   '<path class="st1" d="M17.7,12.1c0,0,0.8,1.2,0.9,1.3s0.1,0.2,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0.1h1L18.5,11L17.7,12.1z"/>',
   '</svg>'
].join('\n');


jQuery(function ($) {

    if (typeof google != 'undefined') {

        var geocoder = null;
        var map = null;
        var customerMarker = null;
        var gmarkers = [];
        var closest = [];
        var bounds = new google.maps.LatLngBounds();
        var loading = false;
        var location_query = getParameterByName('location_search');
        var infobox;
        Z.settings = {
            latlon: '',
            latitude: '42.877742', //center of usa //only used when nothing worked
            longitude: '-97.380979', //center of usa
            countryIso: '', //set in data-country attr
            location: null, //set with geocode
            geoSupport: false,
            clickedLocation: false, //used to highlight the closest location if clicked on
            mapJson: null,
            unitsToUse: 'metric',
            //http://complexdan.com/svg-circleellipse-to-path-converter/
            markerDefaultImage: {
                url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgTemplate),
                scaledSize: new google.maps.Size(25, 34),
                origin: new google.maps.Point(0, 0)
            },
            markerSelectedImage: {
                url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgSelectedTemplate),
                scaledSize: new google.maps.Size(32, 44),
                origin: new google.maps.Point(0, 0)
            },
        };

    } else {
        return false;
    }

    function initialize() {

        //set default from geoip plugin
        if ($("#map-contents").data('lat') && $("#map-contents").data('lon')) {

            Z.settings.latitude = $("#map-contents").data('lat');
            Z.settings.longitude = $("#map-contents").data('lon');
            Z.settings.countryIso = $("#map-contents").data('country');

        }

        Z.settings.latlon = Z.settings.latitude + ',' + Z.settings.longitude;

        $("#center-map").click(function () {
            Z.settings.clickedLocation = false;
            geoLocateHtml5();
        });
        $("#zoom-in").click(function () {
            //set map level zoom -1
            map.setZoom(map.getZoom() + 1);
        });
        $("#zoom-out").click(function () {
            map.setZoom(map.getZoom() - 1);

        });

        $("#address-search").submit(function () {
            Z.settings.clickedLocation = false;
            geoCodeAddress('input'); //uses input value if no param

            return false;
        });

        setupMap();

        addHandlers();

        if (location_query) {
            //link to search results using    ?location_search=seattle
            $('#address').val(location_query);
            Z.settings.clickedLocation = false;
            geoCodeAddress('input'); //uses input value
        } else {
            geoLocateHtml5();
        }

    }

    function loadLocations(type) {
        //console.log(Z.settings.latitude, Z.settings.longitude);

        $.ajax({
            cache: false,
            //timeout: 8000,
            type: "GET",
            dataType: "json",
//          url: 'https://www.nevrohfx.com/wp/wp-admin/admin-ajax.php',
            url: window.pf_url + '/wp/wp-admin/admin-ajax.php',
            data: ({
                action: 'ajax_load_locations',
                lat: Z.settings.latitude,
                lon: Z.settings.longitude,
                type: type
            }),

            success: function (response) {

                Z.settings.mapJson = response;

                if (type == 'listing') {
                    outputListView();
                } else {
                    setupMapMarkers();
                }
            },

            error: function (jqXHR, textStatus, errorThrown) {
                console.log('The following error occured: ' + textStatus, errorThrown);
            },

            complete: function (jqXHR, textStatus) {
                //hide loader
                $('.o-loading-spinner').hide();

            }
        });

    }
    var idleTimer;

    function addHandlers() {

        $("#location-container").on("click", ".location-entry .content", function () {
            //var index = $(this).index();
            Z.settings.clickedLocation = true;
            var markerId = $(this).parent().data("pin");

            $.each(gmarkers, function (index, marker) {
                if (gmarkers[index].id == markerId) {
                    new google.maps.event.trigger(gmarkers[index], 'click');
                }
            })
        })

        $("#location-container").on("click", ".phone-btn", function (e) {
            e.stopPropagation();
        });

        $("#location-container").on("click", ".info-btn", function (e) {
            e.preventDefault();
            var newTop = $("#location-container").position().top * -1;

            $(this).parent().next().css({
                top: newTop
            }).show();
            $(".map-sidebar").addClass("info-open");


            if ($(document).scrollTop() - $("header").outerHeight() > $("header").outerHeight()) {

                var destination = $("#map-contents").offset().top - $("header").outerHeight();
                $("body,html").animate({
                    scrollTop: destination
                }, 800, 'swing');
            }

            //if ($("body").offset().top )
            /*
            		var markerId = $(this).parent().data("pin");
            		var currentMarker = '';

            		$.each(gmarkers, function(index, marker) {
            			if (gmarkers[index].id == markerId) {
            				currentMarker = gmarkers[index];
            			}
            		})

            		new google.maps.event.trigger( currentMarker, 'mouseover' );
            */

            e.stopPropagation();
        })
        $("#location-container").on("click", ".close", function (e) {
            e.preventDefault();
            $(this).parent().hide();
            $(".map-sidebar").removeClass("info-open");
            clickedEntry = false;
            e.stopPropagation();
        })


        //var clickedEntry = $(".map-sidebar").hasClass('info-open');
        var clickedEntry = false;

        //mouseenter mouseleave

        $("#location-container").on("mousedown mouseenter mouseleave", ".location-entry", function (ev) {
            //var index = $(this).index();
            //can't use original markers index because once the order of the list changes independently, they no longer map properly
            var markerId = $(this).data("pin");
            var currentMarker = '';

            $.each(gmarkers, function (index, marker) {
                if (gmarkers[index].id == markerId) {
                    currentMarker = gmarkers[index];
                }
            })

            //mousedown and then mouseout triggers when overlay covers


            if (ev.type === 'mouseenter') {
                new google.maps.event.trigger(currentMarker, 'mouseover');
            } else if (ev.type === 'mousedown') {
                new google.maps.event.trigger(currentMarker, 'mouseover');
                clickedEntry = true;
            } else {
                if (clickedEntry === false) {
                    new google.maps.event.trigger(currentMarker, 'mouseout');
                }
            }
        })

        //mobile version device class added with Mobile_Detect.php
        if ($("body").hasClass("device")) {
            $("#location-container").off("mouseenter mouseleave", ".location-entry");
        }
    }

    function reloadMapCenter() {
        //only triggered from panel or marker click

        var mapCenter = map.getCenter();
        Z.settings.latitude = mapCenter.lat();
        Z.settings.longitude = mapCenter.lng();
        Z.settings.latlon = Z.settings.latitude + ',' + Z.settings.longitude;
        loadLocations('listing');
    }

    function setupMap() {
        geocoder = new google.maps.Geocoder();

        map = new google.maps.Map($('.acf-map:first')[0], {
            zoom: 10, //9 keeps about a 25mile radius with a 540px high map, 10 for 720px
            minZoom: 8,
            scrollwheel: true,
            mapTypeControl: false,

            center: new google.maps.LatLng(Z.settings.latitude, Z.settings.longitude),
            mapTypeId: google.maps.MapTypeId.ROADMAP,

            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false
        });
    }

    function mapPinMouseOver(marker) {
        infobox.setContent(marker.infobox);

        //if (map.getBounds().contains(marker.getPosition())){
        infobox.open(map, marker);
        $('#location-container .location-entry').removeClass('selected');
        $('#location-container .location-entry[data-pin="' + marker.id + '"]').addClass('selected');

        //}

        for (var j = 0; j < gmarkers.length; j++) { //$.each(markers, function(index, marker) {
            gmarkers[j].setIcon(Z.settings.markerDefaultImage);
            gmarkers[j].setZIndex();

        }
        marker.setIcon(Z.settings.markerSelectedImage);
        //bring marker to front
        marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);

    }

    function setupMapMarkers() {
        var marker, i;

        if (infobox !== undefined) {
            infobox.close();
        }
        for (j = 0; j < gmarkers.length; j++) {
            gmarkers[j].setMap(null);
        }
        gmarkers = [];

        if (Z.settings.clickedLocation === false) {

        }

        infobox = new InfoBox({

            disableAutoPan: false,
            alignBottom: true,
            pixelOffset: new google.maps.Size(-115, -50),
            zIndex: 1,
            disableAutoPan: true,
            //closeBoxMargin: "12px 13px 2px 2px",
            closeBoxMargin: "-50px 0 0 0", //hide close button
            closeBoxURL: "",
            infoBoxClearance: new google.maps.Size(1, 1)
        });

        /*
        	need to set back the selected infobox and selected icon
        */

        var markerOutOfView = true;

        var markerClicked = [];

        $(Z.settings.mapJson).each(function (index) {

            var locationMarker = Z.settings.mapJson[index];
            var outputHtml = '';

            //this starting point should be the closest item
            var latlng = new google.maps.LatLng(locationMarker.lat, locationMarker.lng);

            var infoBoxHtml = '<div class="info-container"><div class="store-info">' +
                locationMarker.title +
                '<p>' + locationMarker.short_address + '</p>' +
                '</div></div>';

            //not needed if only setupMapMarkers on zip search
            //if (index == 0){
            //	map.panTo(latlng);
            //}

            outputHtml += getItemHtml(locationMarker, index);

            /*
            if (index == 0){
            	$("#info").empty().append(outputHtml);
            }
            */

            // create marker
            marker = new google.maps.Marker({
                position: latlng,
                map: map,
                icon: Z.settings.markerDefaultImage,
                title: locationMarker.title,
                physicians: locationMarker.physicians,
                address: locationMarker.address,
                short_address: locationMarker.short_address,
                phone: locationMarker.phone,
                email: locationMarker.email,
                website: locationMarker.website,
                html: outputHtml,
                infobox: infoBoxHtml,
                id: locationMarker.id,
                optimized: false
            });

            if (index == 0) {
                //if first marker is in view, don't zoom out to show 3
                if (map.getBounds() && map.getBounds().contains(marker.getPosition())) {
                    markerOutOfView = false;
                }
            }

            if (index == 2 && markerOutOfView) {
                //check if third marker is within view, it's already sorted by distance at this point
                //if first search had on marker, don't zoom out

                for (j = 0; j < 10; j++) { //2 makes the map about 100mile radius

                    if (map.getBounds() && map.getBounds().contains(marker.getPosition())) {
                        break;
                    } else {
                        map.setZoom(map.getZoom() - 1);
                    }
                }
            }

            gmarkers.push(marker);

            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    markerClicked = [];
                    markerClicked['"' + marker.id + '"'] = true;

                    $(".map-sidebar").removeClass("info-open");

                    if ($("body").hasClass("device")) {
                        //do the same actions as hover for device press
                        mapPinMouseOver(marker);
                    }

                    Z.settings.clickedLocation = true;

                    map.panTo(marker.getPosition());
                    reloadMapCenter();

                };
            })(marker, i));

            google.maps.event.addListener(marker, 'mouseover', (function (marker, i) {
                return function () {

                    mapPinMouseOver(marker);

                };
            })(marker, i));

            google.maps.event.addListener(marker, 'mouseout', (function (marker, i) {
                return function () {
                    if (markerClicked['"' + marker.id + '"'] !== true) {

                        //if (map.getBounds().contains(marker.getPosition())){
                        infobox.close();
                        $('#location-container .location-entry').removeClass('selected');
                        //}

                        for (var j = 0; j < gmarkers.length; j++) { //$.each(markers, function(index, marker) {
                            gmarkers[j].setIcon(Z.settings.markerDefaultImage);
                        }

                    }
                };
            })(marker, i));

            if (index == 0 && Z.settings.clickedLocation) {
                marker.setIcon(Z.settings.markerSelectedImage);

                infobox.open(map, marker);
                new google.maps.event.trigger(gmarkers[index], 'click');
            }

        });
        //map.fitBounds(bounds);
        //map.setCenter(bounds.getCenter());
    }

    function geoLocateFail() {
        Z.settings.geoSupport = false;
        $("#center-map").hide();

        //use the default set by geoip plugin
        geoCodeAddress(Z.settings.latlon);
    }

    function geoLocateHtml5() {
        if (loading) {
            return;
        }

        //add customer marker if located
        if (navigator.geolocation) {

            //set timeout to use defaults if user doesn't see the popup
            var locationTimeout = setTimeout(geoLocateFail, 10000);

            navigator.geolocation.getCurrentPosition(function (position) {
                clearTimeout(locationTimeout);

                Z.settings.latitude = position.coords.latitude;
                Z.settings.longitude = position.coords.longitude;

                Z.settings.latlon = Z.settings.latitude + ',' + Z.settings.longitude;

                Z.settings.geoSupport = true;

                geoCodeAddress(Z.settings.latlon); //map.panTo this location on success

                //loadLocations();//ajax load locations,  setupMapMarkers();	outputListView();

            }, function () {

                clearTimeout(locationTimeout);

                //browser supports but, user denied / timeout / no selection made in 15s
                geoLocateFail();

            }, {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }); //timeout doesn't work in IE11 and prob other IEs

        } else {
            //browser doesn't support
            geoLocateFail();

        }
        //getDirections(customerMarker.getPosition(),closest[0].getPosition());
    }
    //triggered by html5 geolocation

    //triggered by search input
    function geoCodeAddress(location) {

        if (loading) {
            return;
        }
        loading = true;
        var geocoderConfig = {};
        if (location === 'input') {
            $("#address").blur(); //close keyboard?
            geocoderConfig.address = document.getElementById('address').value;
            if (Z.settings.countryIso) {
                geocoderConfig.componentRestrictions = {
                    'country': Z.settings.countryIso,
                };
            }
        } else {
            geocoderConfig.address = location;
        }

        geocoder.geocode(geocoderConfig, function (results, status) {

            if (status == google.maps.GeocoderStatus.OK) {
                //map.setCenter(results[0].geometry.location);

                map.setZoom(10);
                //set the lon lat here for the ajax call to return values
                Z.settings.latitude = results[0].geometry.location.lat(); //.G;//H
                Z.settings.longitude = results[0].geometry.location.lng(); //.K;//L  can't use letter, google changes it...

                Z.settings.location = results[0].geometry.location;
                map.panTo(Z.settings.location);

                //if (location !== 'input'){
                loadLocations();

                loadLocations('listing');
                //outputListView();
                //}

            } else {
                $("#location-container").html('<div class="location-error"><p>' + nevro.text.geocode_error + '</p></div>');

                submitGTM('/physician-finder-error/', 'Could not geocode', geocoderConfig.address);
            }

            loading = false;

            $("#map-contents").removeClass("loading");

        });

    }

    function getItemHtml(locationMarker, index) {

        var outputHtml = '';
        var phoneNumber = '';
        var prefix = '+1';
        if(Z.settings.countryIso == 'GB') {
            prefix = '+44';
        }
        if (locationMarker.phone) {
            phoneNumber = locationMarker.phone.match(/\d/g).join("");

            if (phoneNumber.length <= 10) {
                phoneNumber = prefix + phoneNumber;
            }
        }

        outputHtml += '<div class="location-entry"  data-pin="' + locationMarker.id + '">';
        outputHtml += '<div class="content">';
        outputHtml += '<div class="cell">';
        outputHtml += "<h3>" + locationMarker.title + '</h3><p>' + locationMarker.short_address + '</p>';
        outputHtml += '</div>';
        outputHtml += '</div>';
        if (locationMarker.phone) {
            outputHtml += '<a class="phone-btn" tabindex="0" href="tel:' + phoneNumber + '"><div class="icon-phone"></div>' + nevro.text.call + '</a>';
        }
        outputHtml += '<a class="info-btn" href="#"><div class="icon-info"></div><span>' + nevro.text.info + '</span></a>';
        outputHtml += '</div>';
        outputHtml += '<div class="info">';
        outputHtml += '<a class="close" href="#"><span class="icon-closex"></span><span class="sr-only">Close</span></a>';
        outputHtml += '<div class="contents">';
        outputHtml += '<div class="cell">';
        outputHtml += "<h3>" + locationMarker.title + '</h3><p>' + locationMarker.address + '</p>';

        if (locationMarker.physicians) {
            outputHtml += '<div class="physicians">';
            outputHtml += '<h4>' + nevro.text.physicians + '</h4>';

            $.each(locationMarker.physicians, function (i, physician) {
                outputHtml += "<span>" + physician.name + "</span><br />";
            });

            outputHtml += '</div>';
        }

        if (locationMarker.phone) {
            outputHtml += '<a class="phone" tabindex="0" href="tel:' + phoneNumber + '"><span class="icon-phone"></span>' + locationMarker.phone + '</a>';
        }

        if (locationMarker.website) {
            var prefix = '';
            var url = locationMarker.website;
            /*
            var displayUrl = locationMarker.website.replace('www.','').replace('https://','').replace('http://','');
            if (displayUrl.indexOf("/") > -1){
            	displayUrl = displayUrl.split('/');
            	displayUrl = displayUrl[0] + '&hellip;';
            }

            if (displayUrl.length>35){
            	displayUrl = displayUrl.substring(0,35) + '&hellip;';
            }
            */
            if (url.indexOf("http") < 0) {
                prefix = 'http://';
            }
            outputHtml += '<a class="url" tabindex="0" href="' + prefix + url + '" target="_blank"><span class="icon-urlglobe"></span><em>' + nevro.text.website + '</em></a>';
        }

        /* not in comp
        if (locationMarker.email){
        	var prefix = '';
        	var url = locationMarker.email;
        	var emailDisplayUrl = locationMarker.email;//.replace('www.','');
        	if (emailDisplayUrl.length>35){
        		emailDisplayUrl = emailDisplayUrl.substring(0,35) + '&hellip;';
        	}

        	if (url.indexOf("http") < 0){
        		prefix = 'http://';
        	}
        	outputHtml += '<a class="url nevro-facebook-circle-solid" tabindex="0" href="'+prefix+url+'" target="_blank">' + emailDisplayUrl + '</a>';
        }
        */
        outputHtml += '</div>';
        outputHtml += '</div>';
        outputHtml += '</div>';

        return outputHtml;

    }

    function outputListView() {
        var outputHtml = '';

        //outputHtml += '<div class="container">';
        //for (var i = 0; i < 24; i++) {
        $(Z.settings.mapJson).each(function (index) {
            //all items returned in ajax, only limiting list view
            if (index <= 30) {
                var locationMarker = Z.settings.mapJson[index];

                //closest[i].setMap(map);
                outputHtml += getItemHtml(locationMarker, index);

            }
        });

        //outputHtml += '</div>';
        $("#location-container").empty().append(outputHtml);

        $(".map-sidebar").animate({
            scrollTop: 0
        }, 800, 'swing');

    }

    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);

        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    function submitGTM(pageSlug, pageName, locationURL) {
        dataLayer.push({
            'event': 'VirtualPageview',
            'virtualPageURL': pageSlug,
            'virtualPageTitle': pageName,
            'answer': locationURL,
        });
    }

    if (typeof google != 'undefined') {
        if ($(".acf-map").length) {
            google.maps.event.addDomListener(window, 'load', initialize);
        }
    }

    /*
    $(window).resize(function () {
    	//on resize or orientation change
    	$("#location-container .info").attr("style","");
    });
    */
    $(window).on("orientationchange", function () {
        $("#location-container .info").attr("style", "");
    });

});
